module.exports = __webpack_public_path__ + "static/media/CertainTeed.3095adc9.svg";